import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { CreditCardIcon } from '@heroicons/react/24/outline';

import { Modal, ModalContent, Button as ButtonV2, Heading } from '@restworld/ui-ds-base';
import { useAuth } from '@restworld/feature-authentication';

import { isUnpaidInvoicesModalOpenAtom } from '../atoms/unpaid-invoices-modal.atoms';

function UnpaidInvoicesModal() {
  const { t } = useTranslation('jp-onboarding');
  const router = useRouter();
  const { user } = useAuth();
  const [isUnpaidInvoicesModalOpen, setIsUnpaidInvoicesModalOpen] = useAtom(isUnpaidInvoicesModalOpenAtom);

  const handleClose = useCallback(() => {
    setIsUnpaidInvoicesModalOpen(false);
  }, [setIsUnpaidInvoicesModalOpen]);

  const handleGoToPayments = useCallback(() => {
    router.push('/employer/payments-and-invoices');
    handleClose();
  }, [router, handleClose]);

  // Get user's first name for personalization
  const userName = user?.name || 'User';

  return (
    <Modal open={isUnpaidInvoicesModalOpen} onOpenChange={(v) => !v && handleClose()}>
      <ModalContent
        className="md:w-full md:max-w-[640px]"
        title={
          <div className="px-10 text-center">
            <Heading>{t('unpaid_invoices_modal.title', { name: userName })}</Heading>
          </div>
        }
        footer={
          <div className="flex justify-center w-full">
            <ButtonV2 onClick={handleGoToPayments} StartIcon={CreditCardIcon} className="w-full">
              {t('unpaid_invoices_modal.cta')}
            </ButtonV2>
          </div>
        }
      >
        <div className="text-center font-medium text-base text-neutral-90 leading-normal px-10 pb-10">
          {t('unpaid_invoices_modal.description')}
        </div>
      </ModalContent>
    </Modal>
  );
}

export default UnpaidInvoicesModal;
